export default {
  order: 8,
  name: "Training",
  icon: "model_training",
  to: "/training",
};
